import { useDispatch } from "react-redux";
import {
  deselectAll,
  selectAll,
} from "../../redux/reducers/billableItems.reducer";

// Shared by Milestones/Recurring/Resources (BillableItemsResultsPage): the
// "Select" header column with its All/None bulk-selection links is wired up
// identically in all three, parameterized only by the billable-item type.
export const SelectAllNoneHeaderCell = ({
  type,
}: {
  type: "milestones" | "recurring" | "resources";
}) => {
  const dispatch = useDispatch();

  return (
    <th className="small fw-normal text-center border-dark border-top column-10">
      Select
      <div className="d-flex justify-content-center">
        <div
          className="link-text mx-2"
          role="button"
          tabIndex={0}
          onClick={() => dispatch(selectAll({ type }))}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              dispatch(selectAll({ type }));
            }
          }}
        >
          All
        </div>
        /
        <div
          className="link-text mx-2"
          role="button"
          tabIndex={0}
          onClick={() => dispatch(deselectAll({ type }))}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              dispatch(deselectAll({ type }));
            }
          }}
        >
          None
        </div>
      </div>
    </th>
  );
};
